import { useEffect } from 'react'
import { useSetRecoilState } from 'recoil'
import { FireBaseUser, auth } from '../firebase'
import { authUserState, idTokenState } from '../states/atoms'

export const useAuth = () => {
  const setAuthState = useSetRecoilState(authUserState)
  const setIdTokenState = useSetRecoilState(idTokenState)

  const getIdToken = async (user: FireBaseUser) => {
    try {
      const idToken = await user?.getIdToken()
      setIdTokenState({ idToken, isTokenRequested: true })
    } catch (error) {
      setIdTokenState({ idToken: undefined, isTokenRequested: true })
    }
  }

  useEffect(() => {
    //サインインしているかどうかの確認
    try {
      auth.onAuthStateChanged((user) => {
        setAuthState({ user, isAuthRequested: true })
        getIdToken(user)
      })
    } catch (error) {
      console.log(error)
    }
  }, [])
}
